// This utility manages the "What's New" modal display logic

const STORAGE_KEY = "app_last_version_seen";
const CURRENT_VERSION = "0.1.3"; // Keep this in sync with the version in WhatsNewModal

/**
 * Checks if the What's New modal should be displayed based on the current app version
 * and the last version the user has seen
 *
 * @returns {boolean} True if the modal should be shown
 */
export const shouldShowWhatsNewModal = () => {
  const lastVersionSeen = localStorage.getItem(STORAGE_KEY);

  // Show modal if user hasn't seen this version yet
  return lastVersionSeen !== CURRENT_VERSION;
};

/**
 * Marks the current version as seen by the user
 */
export const markVersionAsSeen = () => {
  localStorage.setItem(STORAGE_KEY, CURRENT_VERSION);
};

/**
 * Resets the last seen version (useful for testing)
 */
export const resetLastSeenVersion = () => {
  localStorage.removeItem(STORAGE_KEY);
};
